/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_api_sales_SalesOrderItemResponseDTO = {
    sales_order_item_id: string;
    sales_order_id: string;
    product_variant_id?: string;
    shipping_type_id?: string;
    storage_id?: string;
    bundle_item_id?: string;
    is_bundle_master_item?: boolean;
    product_variant_name?: string;
    status?: co_getplato_grid_api_sales_SalesOrderItemResponseDTO.status;
    sales_price?: number;
    price_scale_factor?: number;
    encrypted_purchase_price?: string;
    line_total?: number;
    position?: string;
    discount_percent?: number;
    quantity?: number;
    gross_margin?: number;
    units?: string;
    text?: string;
    bundleMasterItem?: boolean;
};
export namespace co_getplato_grid_api_sales_SalesOrderItemResponseDTO {
    export enum status {
        OPEN = 'OPEN',
        RELEASED_FOR_DELIVERY = 'RELEASED_FOR_DELIVERY',
        RELEASED_FOR_BILLING = 'RELEASED_FOR_BILLING',
        BILLED = 'BILLED',
        PROCESSED_INTERNALLY = 'PROCESSED_INTERNALLY',
        CANCELLED = 'CANCELLED',
        UNKNOWN = 'UNKNOWN',
        RETURNED = 'RETURNED',
        SHIPPED = 'SHIPPED',
        PARTIALLY_BILLED = 'PARTIALLY_BILLED',
        PARTIALLY_SHIPPED = 'PARTIALLY_SHIPPED',
        PARTIALLY_RECEIVED = 'PARTIALLY_RECEIVED',
        PENDING = 'PENDING',
        RECEIVED = 'RECEIVED',
    }
}

